<template>
  <div></div>
</template>
<script>
export default {
  data () {
    return {}
  },
  created () {
    if (this.$route.query.premium) {
      const query = this.$route.query
      delete query.premium
      this.$router.push({
        name: 'premiumGoodCategoryList',
        query
      })
      return
    }
    this.$router.push({
      name: 'goodSearchCategoryList',
      query: this.$route.query
    })
  }
}
</script>
<style>
</style>
